<template>
  <div id="agSMSConn">
    <b-input-group size="md" prepend="From Phone">
      <b-input type="text" v-model="connection.from" autocomplete="false" :disabled="isReadonly"></b-input>
    </b-input-group>
    <b-input-group size="md" prepend="Account SID">
      <b-input type="text" v-model="connection.username" autocomplete="false" :disabled="isReadonly"></b-input>
    </b-input-group>
    <b-input-group size="md" prepend="Auth Token">
      <b-input type="password" v-model="connection.password" autocomplete="false" :disabled="isReadonly"></b-input>
    </b-input-group>
  </div>
</template>


<script>
// components

// server

// modules

export default {
  name: "ag-sms-conn",

  props: {
    isReadonly: Boolean,
    connection: Object
  },

  data() {
    return {};
  },

  computed: {},

  methods: {
    // UI Events

    // other

    reset() {},

    prepareForSave() {
      let splitNumber = this.connection.from.match(/\d/g);
      if(splitNumber.length === 10 && splitNumber[0] != '1'){
        this.connection.from = "+1" + splitNumber.join("")
      }
      else if(splitNumber.length === 11 && splitNumber[0] == '1'){
        this.connection.from = "+" + splitNumber.join("")
      }
      this.connection.url = "https://www.twilio.com/";
    }
  }
};
</script>


<style scoped lange="css">
</style>


// WEBPACK FOOTER //
// src/components/connection/SMSConnection.vue